import React from 'react';
import { 
    FiBarChart, 
    FiFileText, 
    FiSettings, 
    FiMail, 
    FiTrendingUp,
    FiList,
    FiSend
} from "react-icons/fi";

// --- Icon Map ---
// maps a descriptive key (used in the component prop) to the actual Fi icon component.
const IconMap = {
    // Dashboard and Data Review
    'BarChart': FiBarChart,        
    'Dashboard': FiBarChart,       // Using BarChart for main dashboard
    'ReviewResults': FiTrendingUp, // Using TrendingUp for review results
    
    // Admin
    'FileText': FiFileText,        // Template Management
    'Settings': FiSettings,        // System Settings / Manage Extra Qs
    
    // Leader
    'Mail': FiMail,                // Deploy Survey
    'ManageQs': FiList,            // Manage Extra Questions
    'Send': FiSend,                // Placeholder for send action if needed
};

// --- Stat Card Component ---
const StatCard = ({ title, value, iconName = 'BarChart' }) => {
    // dynamically select the icon component from the map.
    // falls back to FiBarChart if the iconName is not found.
    const IconComponent = IconMap[iconName] || FiBarChart;

    return (
        <div className="bg-white p-4 rounded-xl shadow-md flex items-center justify-between border-l-4 border-indigo-400">
            <div>
                <p className="text-sm font-medium text-gray-500">{title}</p>
                <p className="text-2xl font-semibold text-gray-900">{value}</p>
            </div>
            <div className="text-indigo-400 opacity-50">
                <IconComponent size={32} />
            </div>
        </div>
    );
};

export default StatCard;